<style lang="less" scoped>
#csv {
  display: none;
}
.page-main .page-content .content {
  .searchs {
    height: auto;
  }
  .subbtn {
  }
}
.label-list {
  /deep/ .el-form-item__content {
    width: 136px !important;
  }
}
.table-list {
  padding: 20px 0;
  height: 34px;
}
</style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top">
        <div class="page-content">
          <div class="title">统计选项</div>
          <div class="content">
            <el-form
              label-width="80px"
              :rules="rules"
              :model="ruleForm"
              ref="ruleForm"
            >
              <el-row :gutter="10">
                <div class="searchs">
                  <!-- <el-form-item label="查询日期" prop="time">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      clearable
                    ></el-date-picker>
                  </el-form-item> -->
                  <el-form-item label="时间" prop="startTime">
                    <el-date-picker
                      v-model="ruleForm.startTime"
                      type="datetime"
                      :default-time="'00:00:00'"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="开始时间"
                      clearable
                    ></el-date-picker>
                  </el-form-item>
                  <div class="interval">-</div>
                  <el-form-item label label-width="0" prop="endTime">
                    <el-date-picker
                      v-model="ruleForm.endTime"
                      type="datetime"
                      :default-time="'23:59:59'"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="结束时间"
                      clearable
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="时间段" prop="file_name__icontains">
                    <el-select
                      v-model="ruleForm.file_name__icontains"
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in timeSlot"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="自动站"
                    prop="station"
                    v-if="station.length > 1"
                  >
                    <el-select
                      v-model="ruleForm.station"
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in station"
                        :key="index"
                        :label="item.station_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="" label-width="0" class="label-list">
                    <el-button
                      class="subbtn"
                      @click="search()"
                      type="primary"
                      :loading="submitBtn.isBtnLoading"
                      :disabled="submitBtn.isDisabled"
                      >{{ submitBtn.btnText }}</el-button
                    >
                  </el-form-item>
                </div>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="page-main-bottom">
        <div class="content-list">
          <div class="page-content">
            <div class="title">分析HPGe数据</div>
            <div class="content">
              <a id="csv"></a>
              <div class="table">
                <el-table
                  :empty-text="searchTime ? searchTime + '无数据' : '暂无数据'"
                  :data="tableData"
                  stripe
                  size="mini"
                  border
                  v-loading="pageLoading"
                >
                  <el-table-column
                    v-for="(item, key) in thTableList"
                    :key="key"
                    :prop="item.param"
                    align="center"
                    :label="item.title"
                    :width="item.width"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="item.param === 'file_link'"
                        :titles="scope"
                        class="font-color-theme cursor-pointer"
                        @click="
                          downloadNuclide(scope.row.id, scope.row.file_name)
                        "
                      >
                        下载
                      </div>
                      <div
                        v-else-if="
                          item.param === '' && scope.row.file_type == 'rpt'
                        "
                        class="font-color-theme cursor-pointer"
                        @click="nuclideAnalysis(scope.row.id)"
                      >
                        分析核素
                      </div>
                      <div v-else>{{ scope.row[item.param] }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              class="table-list text-center"
              v-show="pageData.totalCount > 20"
            >
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="pageData.totalCount"
                :page-size="pageData.pageSize"
                :current-page.sync="pageData.currentPage"
                @current-change="pageChange"
                v-if="!pageLoading && pageData.totalCount > 20"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <div class="content-list">
          <div class="page-content">
            <div class="title">数据解析</div>
            <div class="content">
              <div v-loading="nuclideLoading" v-if="nuclideData.length">
                <nuclide-table
                  :tableData="nuclideData"
                  :titleTableData="titleNuclideData"
                ></nuclide-table>
              </div>
              <div
                v-if="!nuclideData.length"
                class="no-data font-color-no text-center"
              >
                暂无数据
              </div>
            </div>
          </div>
          <!-- <information-list :list="nuclideData" :title="'数据解析'"></information-list> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import informationList from "@/components/informationList"; //信息展示
import nuclideTable from "@/components/nuclideTable"; //核素数据展示
export default {
  name: "nuclideIdentification", //核素分析
  components: {
    informationList: informationList,
    nuclideTable: nuclideTable
  },
  data() {
    return {
      pageLoading: false, //页面loading
      nuclideLoading: false, //核素数据解析loading
      pageData: {
        currentPage: 1,
        totalCount: "",
        pageSize: 20
      },
      nuclideData: [], //数据解析
      thTableList: [
        {
          title: "SID",
          param: "sid",
          width: "250"
        },
        {
          title: "监测时间",
          param: "data_time",
          width: "220"
        },
        {
          title: "下载",
          param: "file_link",
          width: "120"
        },
        {
          title: "操作",
          param: "",
          width: "120"
        },
        {
          title: "文件名",
          param: "file_name",
          width: ""
        },
        {
          title: "文件类型",
          param: "file_type",
          width: "80"
        }
      ],
      tableData: [],
      searchTime: null, //点击查询时赋值
      ruleForm: {
        startTime: "",
        endTime: "",
        station: "",
        file_name__icontains: ""
      },
      rules: {
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "change" }
        ],
        station: [
          { required: true, message: "请选择自动站", trigger: "change" }
        ]
      },
      submitBtn: {
        btnText: "查询当天数据",
        isLoading: false,
        isDisabled: false
      },
      timeSlot: [
        {
          name: "全部",
          id: ""
        },
        {
          name: "24小时",
          id: "24_20"
        }
      ],
      station: [], //自动站
      titleNuclideData: [] //核素分析标题
    };
  },
  computed: {
    id: function() {
      return this.$route.params.id || ""; //站点id
    },
    type: function() {
      return this.$route.params.type || ""; //设备type
    }
  },
  methods: {
    search(isSearch) {
      if(!isSearch){
        this.pageData.currentPage = 1;
      }
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let startDate = new Date(this.ruleForm.startTime);
          let endDate = new Date(this.ruleForm.endTime);
          if (startDate > endDate) {
            this.$message.error("开始时间不能大于结束时间");
            return false;
          }
          let time = this.ruleForm.startTime
            ? this.ruleForm.startTime + "," + this.ruleForm.endTime
            : "";
          this.pageLoading = true;
          this.$$http("nuclideIdentification", {
            device: this.ruleForm.station,
            data_time__range: time,
            file_name__icontains: this.ruleForm.file_name__icontains,
            page: this.pageData.currentPage,
            size: this.pageData.pageSize
          })
            .then(results => {
              this.pageLoading = false;
              this.nuclideData = [];
              if (results.data && results.status == 200) {
                this.tableData = results.data.results;
                this.pageData.totalCount = results.data.count;
              } else {
                this.$message.error(
                  results.data.msg ? results.data.msg : "查询失败"
                );
              }
            })
            .catch(err => {
              this.pageLoading = false;
            });
        }
      });
    },
    pageChange() {
      setTimeout(() => {
        this.search(true);
      });
    },
    //下载
    downloadNuclide(id, name) {
      this.$$http("downloadNuclide", {
        id: id
      })
        .then(results => {
          if (results.data && results.status == 200) {
            console.log("下载", results.data);
            let anchor = document.getElementById("csv");
            anchor.href =
              "data:text/csv;charset=utf-8," + encodeURIComponent(results.data);
            anchor.target = "_blank";
            anchor.download = name;
            anchor.click();
            this.$message.success("下载成功");
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "下载失败"
            );
          }
        })
        .catch(err => {});
    },
    //核素分析报告
    nuclideAnalysis(id) {
      this.nuclideLoading = true;
      this.$$http("nuclideAnalysis", {
        id: id
      })
        .then(results => {
          this.nuclideLoading = false;
          if (results.data && results.status == 200) {
            // console.log("数据解析", results.data);
            this.nuclideData = [];
            this.titleNuclideData = [];
            this.nuclideData = results.data.results;
            if (this.nuclideData.length) {
              this.titleNuclideData = [
                {
                  sid: this.nuclideData[0].sid,
                  data_time: this.nuclideData[0].data_time,
                  max_flow: this.nuclideData[0].max_flow
                }
              ];
            }
            // console.log('listsss',this.titleNuclideData)
            for (let i in this.nuclideData) {
              this.nuclideData[i].activityStr = this.nuclideData[i].activity
                ? this.nuclideData[i].activity
                : "<探测限";
            }

            // if (dataList.length) {
            //   this.nuclideData.unshift({
            //     name: "SID",
            //     value: dataList[0].sid,
            //   });
            //   this.nuclideData.push({
            //     name: "更新时间",
            //     value: dataList[0].data_time,
            //   });
            // }
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "获取数据失败"
            );
          }
        })
        .catch(err => {
          this.nuclideLoading = false;
        });
    },
    //获取自动站
    getStationList() {
      this.pbFunc.stationList(this.id).then(res => {
        // console.log("自动站列表", res);
        this.station = res.other_station_devices;
        if (this.station.length == 1) {
          this.ruleForm.station = this.station[0].id;
        }
      });
    }
  },
  created() {
    this.getStationList();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dataStatistics/nuclideIdentification.vue